import { AxiosResponse } from 'axios';
import apiClient from '../axios';
import {
  IFeedResourceEndpointResponse,
  IGetResourceCollectionResponse,
  IGetResourceResponse,
} from '@api/interfaces';
import { UnreadNotificationCount, UserNotification } from './interfaces';

export const getMyNotifications = async (
  limit?: number
): Promise<UserNotification[]> => {
  const response: AxiosResponse<
    IGetResourceCollectionResponse<UserNotification>
  > = await apiClient.get('/notifications', {
    params: limit ? { limit } : undefined,
  });

  return response.data.data;
};

export const getMyNotificationsFeed = async (
  perPage: number,
  cursor?: string | null
): Promise<IFeedResourceEndpointResponse<UserNotification>> => {
  const response: AxiosResponse<
    IFeedResourceEndpointResponse<UserNotification>
  > = await apiClient.get('/notifications', {
    params: {
      perPage,
      cursor: cursor ?? undefined,
    },
  });

  return response.data;
};

export const getMyUnreadNotificationCount = async (): Promise<number> => {
  const response: AxiosResponse<IGetResourceResponse<UnreadNotificationCount>> =
    await apiClient.get('/notifications/unread-count');

  return response.data.data.count;
};

export const markMyNotificationRead = async (
  notificationId: string
): Promise<UserNotification> => {
  const response: AxiosResponse<IGetResourceResponse<UserNotification>> =
    await apiClient.post(`/notifications/${notificationId}/read`);

  return response.data.data;
};

export const markAllMyNotificationsRead = async (): Promise<void> => {
  await apiClient.post('/notifications/read-all');
};
